import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-replicated-value"]
const _hoisted_2 = ["aria-invalid", "value"]

import { debounce } from 'lodash';
import { nextTick, onMounted, ref, useAttrs, useTemplateRef } from 'vue';

type Props = {
  value: string;
  invalid: boolean;
  focus: boolean;
  autoHeight: boolean;
  minHeight: number;
  submitOnEnter: boolean;
};


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false
},
  __name: 'textarea',
  props: {
    value: {},
    invalid: { type: Boolean },
    focus: { type: Boolean },
    autoHeight: { type: Boolean, default: true },
    minHeight: {},
    submitOnEnter: { type: Boolean }
  },
  emits: ["inputValue", "input", "submit", "paste"],
  setup(__props: any, { emit: __emit }) {





const emit = __emit;

const _handlePaste = (event: any) => {
  emit('paste', event.target.value);
};

const handleInput = (event: any) => {
  emit('inputValue', event.target.value);
  emit('input', event);
};

const handlePasteDebounced = ref<(event: any) => void>();

const handlePaste = (event: any) => {
  setTimeout(() => {
    if (handlePasteDebounced.value) {
      handlePasteDebounced.value(event);
    }
  }, 100);
};

const attrs = useAttrs();

const handleKeydown = (event: any) => {
  if (!__props.submitOnEnter) {
    return;
  }
  const { key, ctrlKey, metaKey } = event;
  const shouldSubmit = key === 'Enter' && (ctrlKey || metaKey);
  if (shouldSubmit) {
    event.preventDefault();
    event.stopPropagation();
    emit('submit');
    return;
  }
  return attrs.onKeydown?.(event);
};

const input = useTemplateRef<HTMLTextAreaElement>('input');

onMounted(() => {
  nextTick(() => {
    if (__props.focus && input.value) {
      input.value.focus();
    }
  });
  handlePasteDebounced.value = debounce(_handlePaste, 500);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.autoHeight ? _ctx.$style.growWrap : ''),
    "data-replicated-value": __props.value,
    "data-qa": "textarea"
  }, [
    _createElementVNode("textarea", _mergeProps(_ctx.$attrs, {
      ref_key: "input",
      ref: input,
      "aria-invalid": __props.invalid ? 'true' : 'false',
      class: [
        { 'form-control_invalid': __props.invalid },
        { [_ctx.$style.formControl]: true }
      ],
      style: { minHeight: __props.minHeight },
      value: __props.value,
      onInput: handleInput,
      onPaste: handlePaste,
      onKeydown: handleKeydown
    }), null, 16, _hoisted_2)
  ], 10, _hoisted_1))
}
}

})